"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeDialog = exports.drawAll = exports.writeBg = exports.writeAbove = exports.write = exports.setPos = exports.create = exports.setDefaultLayer = exports.RogueGlyphs = exports.rogueDef = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var rogueMonofont_sidecar_1 = require("./rogueMonofont-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
exports.rogueDef = {
    scale: 0.5,
    sizeX: 16 * 2,
    sizeY: 16 * 2,
};
// TODO: replace these or something?
exports.RogueGlyphs = {
    // '*': rogueMonofont.getSprite('*'),
    // x: rogueMonofont.getSprite('x'),
    target: sprites_sidecar_1.sprites.rogue60,
    back: sprites_sidecar_1.sprites.monofont72,
    back2: sprites_sidecar_1.sprites.monofont73,
    horiz: sprites_sidecar_1.sprites.rogue46,
    '|': sprites_sidecar_1.sprites.rogue47,
    tl: sprites_sidecar_1.sprites.rogue45,
    tr: sprites_sidecar_1.sprites.rogue37,
    bl: sprites_sidecar_1.sprites.rogue35,
    br: sprites_sidecar_1.sprites.rogue36,
    // _default: sprites.rogue00,
};
var objs = [];
var _idx = 0;
// const objsVisible: IMonofontGlyph[] = []
var _defaultLayer = null;
var setDefaultLayer = function (layer) {
    assert_sidecar_1.assert.nil(_defaultLayer, 'default layer already set!');
    _defaultLayer = layer;
};
exports.setDefaultLayer = setDefaultLayer;
// TODO: use sprite recyclers!
var create = function () {
    // Find open glyph, if any
    while (_idx < objs.length) {
        var existing = objs[_idx];
        _idx++;
        if (existing.visible) {
            continue;
        }
        if (existing.timeToStart > 0) {
            continue;
        }
        if (existing.timeLeft > 0) {
            continue;
        }
        // Reset props
        existing.image.alpha = 1;
        existing.timeLeft = 0;
        existing.timeToStart = 0;
        existing.scale = 1;
        return existing;
    }
    assert_sidecar_1.assert.notNil(_defaultLayer, 'need to set default layer for rogueGlyphs!');
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(_defaultLayer, sprites_sidecar_1.sprites.monofont64[0]);
    image.scale = exports.rogueDef.scale;
    var c = {
        x: 0,
        y: 0,
        char: '?',
        frames: sprites_sidecar_1.sprites.monofont64,
        image: image,
        visible: true,
        timeLeft: 0,
        timeToStart: 0,
        floatUp: 0,
        scale: 1,
    };
    // Set props
    c.image.alpha = 1;
    _idx++;
    objs.push(c);
    return c;
};
exports.create = create;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
};
exports.setPos = setPos;
var write = function (x, y, text, color, timeLeft, scale) {
    if (color === void 0) { color = 0xffffff; }
    if (timeLeft === void 0) { timeLeft = 0; }
    if (scale === void 0) { scale = 1; }
    var sprite = exports.RogueGlyphs[text] || null;
    if (!sprite) {
        sprite = rogueMonofont_sidecar_1.rogueMonofont.getSprite(text);
    }
    var c = exports.create();
    c.char = text;
    exports.setPos(c, x, y);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, sprite[0]);
    c.image.tint = color;
    c.visible = true;
    c.timeLeft = timeLeft;
    c.scale = scale;
    c.image.scale = scale * exports.rogueDef.scale;
    c.floatUp = 0;
    return c;
};
exports.write = write;
var writeAbove = function (text, x, y, scale, color, ladder) {
    for (var i = 0; i < text.length; i++) {
        // let scale = 0.5
        var c = exports.write(x + i * scale, y - 1 - (ladder ? i * scale * 0.5 : 0), text[i], color, 0.5, scale);
        c.floatUp = 1;
    }
};
exports.writeAbove = writeAbove;
var writeBg = function (x, y, color, sprite, timeLeft) {
    if (color === void 0) { color = 0xffffff; }
    if (sprite === void 0) { sprite = exports.RogueGlyphs.back; }
    if (timeLeft === void 0) { timeLeft = 0; }
    // let sprite: ISPD[] = RogueGlyphs.back
    var c = exports.create();
    c.char = 'back';
    exports.setPos(c, x, y);
    spritesUtil_sidecar_1.spritesUtil.setPackedFrameSameScale(c.image, sprite[0]);
    c.image.tint = color;
    c.visible = true;
    c.timeLeft = timeLeft;
    c.image.scale = exports.rogueDef.scale;
    c.floatUp = 0;
    return c;
};
exports.writeBg = writeBg;
var drawAll = function () {
    var elapsed = common_sidecar_1.common.getUpdateDelta();
    objs.forEach(function (c) {
        // console.log('drawing glyph', c.x, c.y, c.char)
        c.image.x = Math.floor(c.x * exports.rogueDef.sizeX);
        c.image.y = Math.floor(c.y * exports.rogueDef.sizeY);
        c.image.visible = c.visible;
        c.image.scale = c.scale * exports.rogueDef.scale;
        if (c.timeToStart > 0) {
            c.timeToStart -= elapsed;
            c.image.visible = false;
            if (c.timeToStart <= 0) {
                c.timeToStart = 0;
                c.image.visible = true;
            }
        }
        else {
            if (c.visible) {
                c.timeLeft -= elapsed;
                if (c.floatUp !== 0) {
                    c.y -= elapsed * c.floatUp;
                }
                if (c.timeLeft <= 0) {
                    c.visible = false; // reset
                    c.timeLeft = 0;
                }
            }
        }
    });
    _idx = 0;
};
exports.drawAll = drawAll;
var writeDialog = function (x, y, w, h, title, text, elapsed) {
    if (elapsed === void 0) { elapsed = 9999; }
    var color = rogueColors_1.rogueColors.light;
    var bgColor = rogueColors_1.rogueColors.darkBlue;
    var maxBack = elapsed / 0.002;
    for (var j = 0; j < h; j++) {
        for (var i = 0; i < w; i++) {
            if (i + j * w > maxBack) {
                continue;
            }
            exports.writeBg(x + i, y + j, bgColor);
        }
    }
    for (var i = 1; i < w - 1; i++) {
        if (i === 1 || i > title.length + 1) {
            if (i < maxBack) {
                exports.writeBg(x + i, y, color, exports.RogueGlyphs['horiz']);
            }
        }
        if (i + (h - 1) * w < maxBack) {
            exports.writeBg(x + i, y + h - 1, color, exports.RogueGlyphs['horiz']);
        }
    }
    for (var j = 1; j < h - 1; j++) {
        if (0 + j * h < maxBack) {
            exports.writeBg(x, y + j, color, exports.RogueGlyphs['|']);
        }
        if (w - 1 + j * h < maxBack) {
            exports.writeBg(x + w - 1, y + j, color, exports.RogueGlyphs['|']);
        }
    }
    exports.writeBg(x, y, color, exports.RogueGlyphs.tl);
    exports.writeBg(x + w - 1, y, color, exports.RogueGlyphs.tr);
    exports.writeBg(x, y + h - 1, color, exports.RogueGlyphs.bl);
    exports.writeBg(x + w - 1, y + h - 1, color, exports.RogueGlyphs.br);
    rogueMonofont_sidecar_1.rogueMonofont.write(x + 2, y, title, color);
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x + 1, y + 1, w - 2, text, color, bgColor, elapsed);
};
exports.writeDialog = writeDialog;
